<template>
  <div v-show="chatBotStore.isChatOpen" class="chat-history chat-wrapper">
    <div class="chat-header">
      <h3>
        <img width="40" src="../img/KBuddyIcon.png" alt="KBuddy chat icon" />
        Chat History
      </h3>
      <clear-history-btn />
    </div>

    <chat-history />

    <chat-input />
  </div>
  <button
    v-if="!chatBotStore.isChatOpen"
    class="chat-toggle-btn"
    title="Open chat bot"
    @click="chatBotStore.toggleChat()"
  >
    <img width="50" src="../img/KBuddyIcon.png" alt="KBuddy chat icon" />
  </button>
</template>

<script setup lang="ts">
import ChatHistory from "./chatHistory.vue";
import ChatInput from "./chatInput.vue";
import ClearHistoryBtn from "./clearHistoryBtn.vue";
import { useChatBotStore } from "../stores/chatBotStore";

const chatBotStore = useChatBotStore();
</script>

<style lang="css">
@import "../styles/chatBot.css";
</style>
